module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "FBMHD"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('a', {
    attrs: {
      "href": "#/c01"
    }
  }, [_vm._v("Whoopie")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('a', {
    attrs: {
      "href": "#/c02"
    }
  }, [_vm._v("Tools and Equipment")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('a', {
    attrs: {
      "href": "#/c03"
    }
  }, [_vm._v("Whoopie Recipes")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('a', {
    attrs: {
      "href": "#/c04"
    }
  }, [_vm._v("Chocolate Whoopie")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('a', {
    attrs: {
      "href": "#/c05"
    }
  }, [_vm._v("Vanilla Whoopie")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('a', {
    attrs: {
      "href": "#/c06"
    }
  }, [_vm._v("Red Velvet Whoopie")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apple Pie Whoopie")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banana Whoopie")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coconut Whoopie")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fillings and Toppings")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c10#Buttercream",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vanilla Buttercream Filling")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c10#Marshmallow-Cream-Filling",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marshmallow Cream Filling")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c10#cinn",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cinnamon Cream Cheese Filling")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c10#coco",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coconut and Lime Filling")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c10#cre",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creamy Maple Syrup Filling")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c10#pea",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peanut Butter Cream Filling")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c10#Chocolate-Ganache-Topping",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Ganache Topping")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c10#sug",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sugarpaste")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c10#pet",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Petal Paste")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c10#Royal-Icing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Royal Icing")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Techniques")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c11#Rolling-Out-Sugarpaste",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rolling Out Sugarpaste and Petal Paste")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c11#Cutting-Out-Shapes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cutting Out Shapes")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c11#fril",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frilling")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c11#Shaping-Flowers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shaping Flowers")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c11#Piping",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Piping")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c11#Painting-Faces",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Painting Faces")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c11#Using-Wires",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Using Wires")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c11#Making-Figures",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making Figures")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c11#Colouring",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Colouring")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-CH-T"
  }, [_c('span', {
    attrs: {
      "href": "#/c12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pretty as a Picture")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-CH-T"
  }, [_c('span', {
    attrs: {
      "href": "#/c23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Celebrations")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-CH-T"
  }, [_c('span', {
    attrs: {
      "href": "#/c35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Love is in the Air")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-CH-T"
  }, [_c('span', {
    attrs: {
      "href": "#/c45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Child’s Play")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/supp",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suppliers")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/ata",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/cop",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 60
// module chunks = 0